module.exports = __webpack_public_path__ + "img/header_welcome.76f1e4f5.png";